/*
 * @Author: wbhuangcj
 * @Date: 2021-11-09 19:06:32
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-06-02 09:56:22
 * @Description: 公用js文件
 */
export default {
	created() {
		console.log("使用混入");
		
	},
	data(){
		const pageHeight = window.innerHeight-88+'px';
		const contentHeight = window.innerHeight-187-24+'px';
    const tablePager ={
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    }
    const toolbar ={
      loading: false,
      formData: {
        searchKey: ''
      }
    }
		return {
			contentHeight,
			pageHeight,
      tableData: null,
      tablePager,
      toolbar
		}
	},
	watch:{
		
	},


	computed:{
		
	},
	methods: {
		
	}
}

 